import { Calendar, Plus, Users } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { clientIdFromPath } from '../lib/client-screen';
import TransitionNavLink from './TransitionNavLink';

const itemClass = ({ isActive }: { isActive: boolean }) =>
  `segmented-item px-7 ${isActive ? 'text-primary' : 'text-slate-400'}`;

const MobileNav = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const clientId = clientIdFromPath(location.pathname);
  const newState = {
    ...(clientId ? { clientId } : {}),
    from: `${location.pathname}${location.search}`,
  };

  return (
    <nav className="mobile-nav md:hidden fixed bottom-0 left-0 right-[var(--content-scroll-gutter,0px)] z-40 flex justify-center px-4 pb-[max(1rem,env(safe-area-inset-bottom))] pt-2">
      <div className="mobile-nav-bar segmented flex w-fit items-center gap-4 p-1.5">
        <TransitionNavLink to="/" end aria-label={t('Сегодня')} className={itemClass}>
          <Calendar size={22} />
        </TransitionNavLink>
        <TransitionNavLink to="/new" state={newState} aria-label={t('Добавить')}>
          <span className="flex items-center justify-center w-12 h-12 rounded-full bg-primary text-white shadow-glow">
            <Plus size={26} strokeWidth={2.5} />
          </span>
        </TransitionNavLink>
        <TransitionNavLink to="/clients" aria-label={t('Клиенты')} className={itemClass}>
          <Users size={22} />
        </TransitionNavLink>
      </div>
    </nav>
  );
};

export default MobileNav;
